export const paths = {
  HOME: "/",
  ABOUT: "/about",
  BLOGS: "/blogs",
  BLOGDETAIL: "/blogs/:slug",
  SERVICES: "/services",
  SERVICEDATAIL: "/service/:slug",
  CONTACT: "/contact",
};
